import { useState } from "react";

import { Textarea } from "@/components/_atoms/textarea";
import { useDomainTranslation } from "@/domain/_shared/i18n/use-domain-translation";
import { DATA_REQUEST_FREE_TEXT_MAX_LENGTH } from "@ark/shared";

import type { DataRequestFreeTextQuestion } from "../../models/data-request.model";

interface FreeTextSectionProps {
  questions: DataRequestFreeTextQuestion[];
  initialAnswers: Record<string, string>;
  isReadOnly: boolean;
  onSave: (answers: Record<string, string>) => void;
}

export function FreeTextSection({ questions, initialAnswers, isReadOnly, onSave }: FreeTextSectionProps) {
  const { t } = useDomainTranslation("data-request");
  const [answers, setAnswers] = useState(initialAnswers);

  const handleChange = (questionId: string, value: string) => {
    const updatedAnswers = { ...answers, [questionId]: value };
    setAnswers(updatedAnswers);
    onSave(updatedAnswers);
  };

  return (
    <div className="flex flex-col gap-4 px-6 pb-6">
      <span className="text-sm font-medium">{t("dataEntry.freeText")}</span>
      {questions.map((question) => (
        <div key={question.id} className="flex flex-col gap-1.5">
          <label htmlFor={`free-text-${question.id}`} className="text-sm text-muted-foreground">
            {question.label}
          </label>
          <Textarea
            id={`free-text-${question.id}`}
            value={answers[question.id] ?? ""}
            onChange={(event) => handleChange(question.id, event.target.value)}
            placeholder={t("dataEntry.freeTextPlaceholder")}
            disabled={isReadOnly}
            maxLength={DATA_REQUEST_FREE_TEXT_MAX_LENGTH}
            className="min-h-[100px]"
          />
        </div>
      ))}
    </div>
  );
}
